/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 7,
    height: 12,
    viewBox: '0 0 7 12',
    data: '<defs><path pid="0" d="M15.293 15.463l-3.88-3.88 3.88-3.88a.996.996 0 10-1.41-1.41l-4.59 4.59a.996.996 0 000 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z" id="svgicon_arrow-right_a"/></defs><use _fill="#A9B7C3" transform="rotate(-180 7.793 8.588)" xlink:href="#svgicon_arrow-right_a" fill-rule="evenodd"/>'
  }
})
